'use strict';

(function () {
  'use strict';

  angular.module('vnext').directive('msQuote', msQuote);

  msQuote.$inject = [];

  function msQuote() {
    var directive = {
      bindToController: true,
      controller: ['quoteSvc', function (quoteSvc) {
        var vm = this;
        quoteSvc.getRandomQuote().then(function (quote) {
          vm.quote = quote;
        });
      }],
      controllerAs: 'vm',
      restrict: 'AE',
      templateUrl: 'vnext/templates/quote.html',
      scope: {}
    };
    return directive;
  }
})();